import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=8e6e2922&"
import script from "./Feedback.vue?vue&type=script&lang=js&"
export * from "./Feedback.vue?vue&type=script&lang=js&"
import style0 from "./Feedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e6e2922')) {
      api.createRecord('8e6e2922', component.options)
    } else {
      api.reload('8e6e2922', component.options)
    }
    module.hot.accept("./Feedback.vue?vue&type=template&id=8e6e2922&", function () {
      api.rerender('8e6e2922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Feedback/Feedback.vue"
export default component.exports